import React, { useEffect } from "react";

import { Box, Typography } from "@mui/material";
import Cookies from "js-cookie";
import { makeStyles } from "tss-react/mui";

import nutricoachLogo from "@assets/Nutricoach.png";

const useStyles = makeStyles()({
  logo: {
    objectFit: "cover",
    width: "150px",
    marginBottom: "40px",
  },
  header: {
    fontWeight: 700,
    fontSize: 32,
    lineHeight: "40px",
    textAlign: "center",
    color: "#363E45",
  },
  body: {
    marginTop: "12px",
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "25px",
    textAlign: "center",
    color: "#4C515A",
  },
});

const AccountDeletedPage: React.FC = () => {
  const { classes } = useStyles();

  useEffect(() => {
    Cookies.remove("token");
  }, []);

  return (
    <Box
      height="100vh"
      width="100vw"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bgcolor="white"
    >
      <img src={nutricoachLogo} className={classes.logo} />
      <Box maxWidth={513}>
        <Typography className={classes.header}>
          We are sad to see you go.
        </Typography>
        <Typography className={classes.body}>
          All of your data will be permanently removed from our system after 30
          days.
        </Typography>
      </Box>
    </Box>
  );
};

export default AccountDeletedPage;
